




























































































































































































import Vue from "vue";
import userInfoProvider from "@/services/userInfoProvider";
import OtpFormInput from "../partials/OtpFormInput.vue";
import identityAuthenClient from "@/services/identityAuthenClient";
import defaultDataProviderFactory from "@/services/identity-authen/defaultDataProvider";
import {
  LOWER_CASE_REGEX,
  STRING_CONTAIN_NUMBER_REGEX,
  UPPER_CASE_REGEX,
} from "@/constant/regex";
import router from "@/router";
const defaultDataProvider = defaultDataProviderFactory();

export default Vue.extend({
  name: "ForgotPassword",
  components: { OtpFormInput },
  data() {
    const self: any = this;
    return {
      messageForTheFirstTime: "",
      formValue: {
        newPassword: "",
        confirmPassword: "",
      },
      matchPassword: null as any,
      passwordCondition: {
        length: false,
        numberCharacter: false,
        leterCase: false,
      },
      rules: {
        required: (value) => {
          return !!value || "Required";
        },
        newPassword: (value) => {
          return self.doneTypingNewPassword() || "invalid";
        },
        comparePassword: (value) => {
          return self.comparePassword() || "Not match";
        },
      },
      error: "",
      changePasswordForFirstTime: false,
      loading: false,
      isShowSelectMethod: false,
      message: "",
      otp: "",
      data: {},
      token: "",
      totpCodeInput: ["", "", "", "", "", ""],
      isWaiting: false,
      form: false,
      confirmPasswordDirty: false,
      smsMethod: false,
      emailMethod: false,
      selectingMethod: false,
      validOtp: false,
    };
  },
  methods: {
    goBack() {
      if (!this.isShowSelectMethod && this.data.available_types.length > 1) {
        this.isShowSelectMethod = true;
      } else {
        router.push({ name: "forgot-password" });
      }
    },
    clear() {
      this.formValue = {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      };
    },
    async selectMethodOption(typeMethod) {
      this.selectingMethod = true;
      const query: any = {
        loginName: this.data.query.loginName,
        type: typeMethod,
      };
      try {
        const data = await identityAuthenClient.requestChangePassword(query);
        if (data) {
          const errorInfo = data.error_info;
          if (
            errorInfo &&
            errorInfo.message !== "" &&
            Object.keys(errorInfo).length
          ) {
            this.error = errorInfo.message;
            this.selectingMethod = false;
            return;
          }
          if (typeMethod === "Sms") {
            this.token = data.token;
            this.smsMethod = true;
          } else if (typeMethod === "Email") {
            this.smsMethod = false;
          }
          this.isShowSelectMethod = false;
          this.message = data.message;
          this.selectingMethod = false;
        }
      } catch (error) {
        this.error = error;
        this.selectingMethod = false;
      }
    },
    focusConfirmPassword() {
      this.confirmPasswordDirty = true;
    },
    validateAll(event) {
      (this.$refs.form as any).validate();

      // If key is enter
      if (event.which === 13 || event.keyCode === 13) {
        if (this.form) {
          this.changePassword();
        }
      }
    },
    comparePassword() {
      if (this.confirmPasswordDirty) {
        if (this.formValue.newPassword === this.formValue.confirmPassword) {
          this.matchPassword = true;
          return true;
        }
        this.matchPassword = false;
        return false;
      }
      return true;
    },
    doneTypingNewPassword() {
      let valid: any = true;
      if (this.formValue.newPassword.length >= 8) {
        this.passwordCondition.length = true;
      } else {
        this.passwordCondition.length = false;
        valid = false;
      }

      if (STRING_CONTAIN_NUMBER_REGEX.test(this.formValue.newPassword)) {
        this.passwordCondition.numberCharacter = true;
      } else {
        this.passwordCondition.numberCharacter = false;
        valid = false;
      }

      if (
        this.formValue.newPassword.match(LOWER_CASE_REGEX) &&
        this.formValue.newPassword.match(UPPER_CASE_REGEX)
      ) {
        this.passwordCondition.leterCase = true;
      } else {
        this.passwordCondition.leterCase = false;
        valid = false;
      }
      return valid;
    },
    onReadyToSubmit(mfaData) {
      this.otp = mfaData.otp;
      this.validOtp = true;
    },
    async submit() {
      this.isWaiting = true;
      this.error = "";
      let query: any;

      query = {
        newPassword: this.formValue.newPassword,
        otp: this.otp,
        token: this.token,
        type: this.emailMethod ? "Email" : "Sms",
      };
      try {
        const data = await identityAuthenClient.resetPassword(query);
        const errorInfo = data.error_info;
        if (errorInfo && errorInfo.message !== "" && Object.keys(errorInfo).length) {
          this.error = errorInfo.message;
          this.isWaiting = false;
          return;
        }
        this.isWaiting = false;
        data.type = 'changePwdSuccess';
        if (this.changePasswordForFirstTime) {
          router.push({ name: "username-password", params: data });
        } else {
          router.push({ name: "forgot-password-result", params: data });
        }
      } catch (error) {
        this.error = error;
        this.isWaiting = false;
      }
    },
    haveAllowMethod() {
      let countAllowMethod = 0;
      if (this.data && this.data.available_types && this.data.available_types.length > 0) {
        for (const method of this.data.available_types) {
          if (method.type === 'Sms' || method.type === 'Email') {
            countAllowMethod += 1;
          }
        }
        if (countAllowMethod === 2) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    containMethod(type) {
      for (const method of this.data.available_types) {
        if (method.type === type) {
          return true;
        }
      }
      return false;
    }
  },
  async created() {
    if (this.$route.params !== null) {
      this.data = this.$route.params;
    } else {
      router.push({ name: "forgot-password" });
    }

    if (this.$route.query.token) {
      this.emailMethod = true;
      this.validOtp = true;
      this.isShowSelectMethod = false;
      this.token = this.$route.query.token;
    }

    if (this.data.available_types && this.data.available_types.length > 1 && this.haveAllowMethod()) {
      this.isShowSelectMethod = true;
    } else if ( this.data.available_types && this.containMethod("Sms")) {
      this.smsMethod = true;
      await this.selectMethodOption("Sms");
    } else if (this.data.available_types && this.containMethod("Email")) {
      this.smsMethod = false;
      await this.selectMethodOption("Email");
    } else if (this.data.error_info && this.data.error_info.error_code === 205 && this.data.token) {
      this.messageForTheFirstTime = this.data.error_info.message
      this.token = this.data.token
      this.changePasswordForFirstTime = true
      this.smsMethod = false;
      this.emailMethod = true;
      this.isShowSelectMethod = false;
      this.validOtp = true;
    }
  },
});
